'use client';

import HeroSection from '@/components/home/HeroSection';
import LeadListsSection from '@/components/home/LeadListsSection';
import { ShieldCheck } from 'lucide-react';
import { JSX } from 'react';

export default function HomePageContent(): JSX.Element {
  return (
    <>
      <HeroSection />
      <LeadListsSection />
      <div className="text-center py-6 text-sm text-gray-600 dark:text-gray-300">
        <ShieldCheck className="inline-block w-4 h-4 mr-1.5 text-green-600 dark:text-green-400 align-text-bottom" />
        All list purchases come with a 24-hour money-back guarantee if the data doesn&apos;t match
        the description.
      </div>
    </>
  );
}
